import { APP_KEY_IDS } from "../../../constants/constants";
import BaseMobileAppContainer from "../base-mobile-app-container/BaseMobileAppContainer";
import Styles from "./GalaxyStore.module.scss";
import classnames from "classnames"


//Icons
import { ReactComponent as HomeIcon } from "../../../icons/extra_icons/home.svg"
import { ReactComponent as GameIcon } from "../../../icons/extra_icons/smasung_game.svg"
import { ReactComponent as StarIcon } from "../../../icons/extra_icons/samsung_favourite.svg"
import { ReactComponent as WatchIcon } from "../../../icons/extra_icons/samsung_watch.svg"
import { ReactComponent as PlayIcon } from "../../../icons/extra_icons/play.svg"
import Poster from "../../../icons/extra_icons/samsung_galaxy_store_poster.webp"
import { useState } from "react";
import AppMainScreen from "../../app-store/app-main-screen/AppMainScreen";

interface GalaxyStoreProps {
    allApps: any;
}

const GalaxyStore = ({ allApps }: GalaxyStoreProps) => {

    const [activeId,setActiveId]=useState({
        id:"",
        label:"",
        description:"",
        icon:"",
        images:[],
        type:-1,
    })

    const handleAppClick=(app:any)=>{
        setActiveId(app)
    }

    const handleBackClick=()=>{
        setActiveId({
            id:"",
            label:"",
            description:"",
            icon:"",
            images:[],
            type:-1,
    })
    }

    return (
        <BaseMobileAppContainer
            appId={APP_KEY_IDS.MOBILE_GALAXY_STORE}
            title={""}
            MainMenuOptions={
                <div className={Styles.main_container}>
                    <div className={Styles.screen}>
                        <div className={Styles.top_screen}>
                            <img src={Poster} />
                        </div>
                        <div className={Styles.option_screen}>
                            <div className={Styles.top_header}>
                                {
                                    Object.keys(allApps).map((category: string) => {
                                        return (
                                            <div  className={classnames(Styles.category_label)} key={category}>
                                                {allApps[category].label}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className={Styles.apps_screen_container}>
                                {
                                    Object.keys(allApps).map((category: any) => {
                                        return (
                                            <section className={Styles.apps_screen} id={category} key={category}>
                                                <div className={Styles.title}>
                                                    {allApps[category].label}
                                                </div>
                                                <div className={Styles.apps}>
                                                    {
                                                        Object.values(allApps[category].options).map((app: any) => {
                                                            return (
                                                                <div className={Styles.app_tile} onClick={()=>{handleAppClick(app)}} key={app.id}>
                                                                    <div className={Styles.icon}>
                                                                        <img src={app.icon} />
                                                                    </div>
                                                                    <div className={Styles.label}>
                                                                        {app.label}
                                                                    </div>
                                                                    <div className={Styles.play}>
                                                                        <PlayIcon/>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </section>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className={Styles.navigation_bar_container}>
                        <NavigationBar />
                    </div>
                </div>

            }
            MainScreen={
            <AppMainScreen 
                title={activeId.label} 
                icon={activeId.icon} 
                description={activeId.description} 
                type={activeId.type} 
                screenshots={activeId.images ? Object.values(activeId.images) : []} 
                />
            }
            isMainScreenActive={!!activeId.id}
            handleBackClick={handleBackClick}
        />
    )
}

export default GalaxyStore

const NavigationBar = () => {

    const NAV_BAR = [
        {
            id: 'home',
            icon: <HomeIcon />,
            label: "Home"
        },
        {
            id: 'game',
            icon: <GameIcon />,
            label: "Game"
        },
        {
            id: 'favourite',
            icon: <StarIcon />,
            label: "My Galaxy"
        },
        {
            id: 'watch',
            icon: <WatchIcon />,
            label: "Watch"
        },
    ]


    return (
        <div className={Styles.navigation_bar}>
            {
                NAV_BAR.map((option: any, index: number) => {
                    return (
                        <div className={classnames(Styles.option, index === 0 && Styles.active)} key={option.id}>
                            <div className={Styles.icon}>{option.icon}</div>
                            <div className={Styles.label}>{option.label}</div>
                        </div>
                    )
                })
            }
        </div>
    )
}